import { useState, useEffect } from "react";
import Select from 'react-select';

const CboGrupo = ({ selectedValue, onChange, disabled, grusu }) => {

  const [grupos, setGrupos] = useState([]);
  const [verGrupos, setVerGrupos] = useState(false);

  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grusu = grusu;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/gru/allgrupos`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data;
        console.log("Grupos y cantidad:", json3.data/*, json3.data[0].Gru_IdGru, json3.data*/);

        setGrupos(json3.data);
        if (json3.data.length > 0) {
          setVerGrupos(true);
          const primerId = json3.data[0].Gru_IdGru;
          // Creamos un objeto que simule el evento de cambio para no romper la lógica del componente padre
          const eventoSimulado = {
            target: {
              value: primerId
            }
          };
          onChange(eventoSimulado);
        }
      })


  }, []);

  const opcionesGrupo = [
    { value: 0, label: 'todos los grupos' },

    ...grupos.map((unolista) => ({
      value: unolista.Gru_IdGru,
      label: unolista.Gru_Nombre
    }))
  ];

  const grupoSeleccionado =
    opcionesGrupo.find(op => op.value === selectedValue);


  return (

    /*  <select className={`form-control form-select mb-3 `} value={selectedValue} onChange={onChange} disabled={disabled}  >
              <option value=""></option>
    
              {grupos.map((unolista, index) => (
                <option key={index + '_opt'} value={unolista.Gru_IdGru}>{unolista.Gru_Nombre}</option>
              )
              )
              }
    
            </select>*/



    <div className={verGrupos ? "col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4" : "col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4 d-none"}>
      <div className="form-group">
        <label className="l" >
          Grupo
        </label>

        <Select
          classNamePrefix="miSelect"
          isSearchable={false}
          options={opcionesGrupo}
          value={grupoSeleccionado}
          onChange={(opcion) =>
            onChange({
              target: {
                value: opcion.value || 0
              }
            })
          }
          isDisabled={disabled}
        />

      </div>
    </div>
  );
};

export default CboGrupo;